import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  VStack,
  Heading,
  Text,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import BazarForm from '../components/Bazar/BazarForm';

export default function BazarNew() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  // Redirect se non autenticato
  React.useEffect(() => {
    if (!isAuthenticated) {
      navigate('/bazar');
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  const handleSuccess = () => {
    navigate('/bazar');
  };

  return (
    <Container maxW="container.md" py={8}>
      <VStack spacing={6} align="stretch">
        <Box>
          <Heading size="lg" mb={2}>
            Inserisci un nuovo oggetto
          </Heading>
          <Text color={useColorModeValue('gray.600', 'gray.400')}>
            Compila il form per aggiungere un oggetto al Bazar
          </Text>
        </Box>

        <BazarForm onSuccess={handleSuccess} />
      </VStack>
    </Container>
  );
}
